import {
    GEO_ADDRESS,
    GEO_ADDRESS_SUCCESS,
    GEO_ADDRESS_FAILURE,
} from '../actions/action-types';

/**
 * initial state
 */
const INIT_STATE = {
    data: null,
    error: null,
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GEO_ADDRESS:
            return { ...state, loading: true };

        case GEO_ADDRESS_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case GEO_ADDRESS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default: return state;
    }
}
